import * as types from '../constants/actionTypes';

// Login actions
export const loginRequest = (credentials) => ({
  type: types.LOGIN_REQUEST,
  payload: credentials,
});

export const loginSuccess = (data) => ({
  type: types.LOGIN_SUCCESS,
  payload: data,
});

export const loginFailure = (error) => ({
  type: types.LOGIN_FAILURE,
  payload: error,
});

// Signup actions
export const signupRequest = (userData) => {
  console.log('Creating signupRequest action with userData:', userData);
  const action = {
    type: types.SIGNUP_REQUEST,
    payload: userData,
  };
  console.log('Created action:', action);
  return action;
};

export const signupSuccess = (data) => ({
  type: types.SIGNUP_SUCCESS,
  payload: data,
});

export const signupFailure = (error) => ({
  type: types.SIGNUP_FAILURE,
  payload: error,
});

// Logout action
export const logout = () => ({
  type: types.LOGOUT,
});

// UI actions
export const setLoading = (status) => ({
  type: types.SET_LOADING,
  payload: status,
});

export const setError = (error) => ({
  type: types.SET_ERROR,
  payload: error,
});

export const clearError = () => ({
  type: types.CLEAR_ERROR,
});

// Forgot Password actions
export const forgotPasswordRequest = (email) => ({
  type: types.FORGOT_PASSWORD_REQUEST,
  payload: email,
});

export const forgotPasswordSuccess = (data) => ({
  type: types.FORGOT_PASSWORD_SUCCESS,
  payload: data,
});

export const forgotPasswordFailure = (error) => ({
  type: types.FORGOT_PASSWORD_FAILURE,
  payload: error,
});

// Reset Password actions
export const resetPasswordRequest = (token, password) => ({
  type: types.RESET_PASSWORD_REQUEST,
  payload: { token, password },
});

export const resetPasswordSuccess = (data) => ({
  type: types.RESET_PASSWORD_SUCCESS,
  payload: data,
});

export const resetPasswordFailure = (error) => ({
  type: types.RESET_PASSWORD_FAILURE,
  payload: error,
});

// Change Password actions
export const changePasswordRequest = (currentPassword, newPassword) => ({
  type: types.CHANGE_PASSWORD_REQUEST,
  payload: { currentPassword, newPassword },
});

export const changePasswordSuccess = (data) => ({
  type: types.CHANGE_PASSWORD_SUCCESS,
  payload: data,
});

export const changePasswordFailure = (error) => ({
  type: types.CHANGE_PASSWORD_FAILURE,
  payload: error,
});

// Email Verification actions
export const verifyEmailRequest = (token) => ({
  type: types.VERIFY_EMAIL_REQUEST,
  payload: token,
});

export const verifyEmailSuccess = (data) => ({
  type: types.VERIFY_EMAIL_SUCCESS,
  payload: data,
});

export const verifyEmailFailure = (error) => ({
  type: types.VERIFY_EMAIL_FAILURE,
  payload: error,
});

// Resend Verification actions
export const resendVerificationRequest = (email) => ({
  type: types.RESEND_VERIFICATION_REQUEST,
  payload: email,
});

export const resendVerificationSuccess = (data) => ({
  type: types.RESEND_VERIFICATION_SUCCESS,
  payload: data,
});

export const resendVerificationFailure = (error) => ({
  type: types.RESEND_VERIFICATION_FAILURE,
  payload: error,
});

// User Profile actions
export const getProfileRequest = () => ({
  type: types.GET_PROFILE_REQUEST,
});

export const getProfileSuccess = (data) => ({
  type: types.GET_PROFILE_SUCCESS,
  payload: data,
});

export const getProfileFailure = (error) => ({
  type: types.GET_PROFILE_FAILURE,
  payload: error,
});

// Update Profile actions
export const updateProfileRequest = (userData) => ({
  type: types.UPDATE_PROFILE_REQUEST,
  payload: userData,
});

export const updateProfileSuccess = (data) => ({
  type: types.UPDATE_PROFILE_SUCCESS,
  payload: data,
});

export const updateProfileFailure = (error) => ({
  type: types.UPDATE_PROFILE_FAILURE,
  payload: error,
});

// Permission actions
export const setPermissions = (permissions) => ({
  type: types.SET_PERMISSIONS,
  payload: permissions,
});

export const clearPermissions = () => ({
  type: types.CLEAR_PERMISSIONS,
});